import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const fetchFacilities = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== "" && value !== null && value !== undefined)
  );
  const response = await api.get("/facilities", { params });
  return response.data;
};

export const fetchFacility = async (facilityId) => {
  const response = await api.get(`/facilities/${facilityId}`);
  return response.data;
};

export const fetchStats = async () => {
  const response = await api.get("/stats");
  return response.data;
};

export const submitRating = async (facilityId, payload) => {
  const response = await api.post(`/facilities/${facilityId}/ratings`, payload);
  return response.data;
};

export const createFacility = async (payload) => {
  const response = await api.post("/facilities", payload);
  return response.data;
};

export const submitListingRequest = async (payload) => {
  const response = await api.post("/listing-requests", payload);
  return response.data;
};